import React, { useState } from 'react';
import  './EmailandSms.css';
import { Link } from 'react-router-dom';

const EmailandSms = () => {
  
    const [type, setType] = useState('');
    const [category, setCategory] = useState('');
    const [description, setDescription] = useState('');
    const [template, setTemplate] = useState(
        
    );

    // Function to handle inserting merge fields into the template
  

    return (
        <div className="edit-template">
            <h2>Email & SMS Settings</h2>
            <form>
                
                

                <div className="form-group">
                    <label>Type</label>
                    <select value={type} onChange={(e) => setType(e.target.value)}>
                        <option>Select </option>
                        <option>SMS</option>
                        <option>Email</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Category</label>
                    <input type="text" value={category} onChange={(e) => setCategory(e.target.value)} />
                </div>

                <div className="form-group">
                    <label>Description</label>
                    <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
                </div>

                <div className="form-group">
                    <label>Template</label>
                    <div className="template-editor">
                        
                        <textarea
                            value={template}
                            onChange={(e) => setTemplate(e.target.value)}
                            rows="8"
                        />
                    </div>
                </div>

                <div className="form-group">
                    <Link to="/admin">
                    <button type="submit" className="btn-save">Send</button>
                    </Link>
                
                </div>
            </form>
        </div>
    );
};

export default EmailandSms;
